export default function responseFactory() {
  return {
    message: '',
    success: false,
    data: null,
  };
}
